import { createSlice } from "@reduxjs/toolkit";

//STATE
const state = {
  rows: [],
  itemStatusDelete: {},
  showDialog: false,
  isLoading: false,
};

//STORE SLICE
export const itemStatusDeleteSlice = createSlice({
  name: "itemStatusDeleteSlice",
  initialState: state,
  //REDUCER
  reducers: {
    showDeleteItemStatusDialog(state, action) {
      return {
        ...state,
        showDialog: true,
        itemStatusDelete: action.payload,
      };
    },
    closeDeleteItemStatusDialog(state) {
      return {
        ...state,
        showDialog: false,
      };
    },
    showLoading(state) {
      return {
        ...state,
        isLoading: true,
      };
    },
    hideLoading(state) {
      return {
        ...state,
        isLoading: false,
      };
    },    
  },
});

//ACTIONS
export const {
  showDeleteItemStatusDialog,
  closeDeleteItemStatusDialog,
  showLoading,
  hideLoading
} = itemStatusDeleteSlice.actions;

export default itemStatusDeleteSlice.reducer;
